module.exports = __webpack_public_path__ + "static/media/laurel.11701225.png";